import React, { FC, useEffect } from 'react';

import { Trans } from 'react-i18next';

import { Box } from '@adsk/alloy-react-box';
import { useTrackReady } from '@adsk/exo-skeleton-react';

import { ProjectListErrorBoundery } from '../ProjectListErrorBoundery';
import useProductLinks from './hooks/useProductLinks';
import ProductLinksBar from './layout/ProductLinksBar';
import ProductLinksSection from './layout/ProductLinksSection';

const ProductLinks: FC = () => {
  const { trackReadyOnce } = useTrackReady();
  const { internalProductLinks, externalProductLinks } = useProductLinks();

  useEffect(() => {
    trackReadyOnce();
  }, [trackReadyOnce]);

  return (
    <ProductLinksBar>
      <ProductLinksSection links={internalProductLinks} />
      <Box flex={1} />
      <ProductLinksSection
        links={externalProductLinks}
        helperText={<Trans i18nKey="MORE_AUTODESK_PRODUCTS" />}
        collapseOnSmallScreens
      />
    </ProductLinksBar>
  );
};

const ProductLinksWithErrorBoundery = () => (
  <ProjectListErrorBoundery>
    <ProductLinks />
  </ProjectListErrorBoundery>
);

export default ProductLinksWithErrorBoundery;
